export const tableMixin = {
    data(){
        return {
            checkFixed:false,
            operationFixed:false,
        }
    },
    methods:{
        isHorizontalSrcoll(){
            let headerWrapper = document.querySelector(".el-table__header-wrapper");
            let header = document.querySelector(".el-table__header");
            let headerWrapperWidth = headerWrapper.offsetWidth;
            let headerWidth = header.offsetWidth;
            if(headerWidth>headerWrapperWidth){
                // console.log("出现横向滚动")
                this.checkFixed = true;
                this.operationFixed = "right";
            }else{
                // console.log("没有横向滚动")
                this.checkFixed = false;
                this.operationFixed = false;
            }
        }
    },
    mounted(){
        this.$nextTick(()=>{
            this.isHorizontalSrcoll();
        })
        window.onresize = () => {
            this.isHorizontalSrcoll();
        }
    }
}